import { useMutation, gql } from '@apollo/client';
import {
  CadastrarPeriodoMutation,
  CadastrarPeriodoMutationVariables,
} from './__generated__/CadastrarPeriodoMutation';

const CADASTRAR_PERIODO_MUTATION = gql`
  mutation CadastrarPeriodoMutation(
    $dsc_periodo: String!
    $dat_inicio: String!
    $dat_fim: String!
  ) {
    cadastrarPeriodo(
      input: { dsc_periodo: $dsc_periodo, dat_inicio: $dat_inicio, dat_fim: $dat_fim }
    ) {
      id_periodo
      dsc_periodo
      dat_inicio
      dat_fim
    }
  }
`;

const useCadastrarPeriodoMutation = () => {
  return useMutation<CadastrarPeriodoMutation, CadastrarPeriodoMutationVariables>(
    CADASTRAR_PERIODO_MUTATION
  );
};

export { useCadastrarPeriodoMutation };
